export const widgetBaseStyles = `
.pillow-container {
  position: fixed;
  bottom: 20px;
  z-index: 999999;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}
.pillow-backdrop {
  --pillow-backdrop-color: #0f172a;
  --pillow-backdrop-alpha: 0.42;
  --pillow-backdrop-blur: 6px;
  position: fixed;
  inset: 0;
  background: transparent;
  backdrop-filter: blur(0px);
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 220ms cubic-bezier(0.22, 1, 0.36, 1),
    visibility 220ms cubic-bezier(0.22, 1, 0.36, 1),
    backdrop-filter 220ms cubic-bezier(0.22, 1, 0.36, 1);
}
.pillow-backdrop::before {
  content: '';
  position: absolute;
  inset: 0;
  background: var(--pillow-backdrop-color);
  opacity: 0;
  transition: opacity 220ms cubic-bezier(0.22, 1, 0.36, 1);
}
.pillow-container.position-left { left: 20px; }
.pillow-container.position-right { right: 20px; }
.pillow-container.embedded {
  position: relative;
  inset: auto;
  width: 100%;
  height: 100%;
}
.pillow-container.presentation-embed .pillow-backdrop,
.pillow-container.presentation-overlay .pillow-backdrop {
  display: none;
}
.pillow-container.presentation-modal {
  inset: 0;
  bottom: auto;
  left: 0;
  right: 0;
  pointer-events: none;
}
.pillow-container.presentation-modal .pillow-backdrop {
  backdrop-filter: blur(0px);
}
.pillow-container.presentation-modal .pillow-window,
.pillow-container.presentation-modal .pillow-backdrop {
  pointer-events: auto;
}
.pillow-container.presentation-modal.is-open .pillow-backdrop {
  opacity: 1;
  visibility: visible;
  backdrop-filter: blur(var(--pillow-backdrop-blur));
}
.pillow-container.presentation-modal.is-open .pillow-backdrop::before {
  opacity: var(--pillow-backdrop-alpha);
}
.pillow-window {
  position: absolute;
  width: 400px;
  height: 600px;
  bottom: 20px;
  border-radius: 24px;
  background: white;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12), 0 1px 6px rgba(0, 0, 0, 0.08);
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px) scale(0.95);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}
.pillow-container.position-left .pillow-window { left: 0; }
.pillow-container.position-right .pillow-window { right: 0; }
.pillow-container.presentation-modal .pillow-window {
  position: fixed;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  width: min(720px, calc(100vw - 32px));
  height: min(720px, calc(100vh - 48px));
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 48px);
  opacity: 0;
  transform: translate(-50%, calc(-50% + 22px)) scale(0.94);
  transition:
    opacity 240ms cubic-bezier(0.22, 1, 0.36, 1),
    transform 280ms cubic-bezier(0.16, 1, 0.3, 1),
    visibility 240ms cubic-bezier(0.22, 1, 0.36, 1);
  will-change: opacity, transform;
}
.pillow-window.open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
}
.pillow-container.presentation-modal .pillow-window.open {
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
}
.pillow-container.embedded .pillow-window {
  position: relative;
  inset: auto;
  width: 100%;
  height: 100%;
  opacity: 1;
  visibility: visible;
  transform: none;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.05);
  border: 1px solid #e5e7eb;
}
.pillow-iframe {
  width: 100%;
  height: 100%;
  border: 0;
  background: white;
}
.pillow-window-close {
  position: absolute;
  top: 20px;
  right: 14px;
  width: 32px;
  height: 32px;
  border: none;
  background: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 4;
  transition:
    background-color 180ms cubic-bezier(0.22, 1, 0.36, 1),
    color 180ms cubic-bezier(0.22, 1, 0.36, 1);
}
.pillow-window-close:hover,
.pillow-window-close:focus-visible {
  background: #f3f4f6;
}
.pillow-window-close:focus-visible {
  outline: 2px solid #d1d5db;
  outline-offset: 2px;
}
.pillow-window-close svg {
  width: 20px;
  height: 20px;
  color: #666;
}
@media (max-width: 480px) {
  .pillow-window {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
  .pillow-container.presentation-modal .pillow-window {
    inset: 12px;
    top: auto;
    left: auto;
    width: auto;
    height: auto;
    max-width: none;
    max-height: none;
    border-radius: 24px;
    transform: translateY(24px) scale(0.97);
  }
  .pillow-container.presentation-modal .pillow-window.open {
    transform: translateY(0) scale(1);
  }
}
`;
//# sourceMappingURL=widget-styles.js.map